<div class="row-actions" dropdown [container]="container" placement="bottom end" #dd="bs-dropdown">
  <button type="button" class="row-actions-toggle" dropdownToggle aria-haspopup="true" [attr.aria-expanded]="dd.isOpen">
    {{ label | translate }}
    <i class="fas fa-chevron-down" aria-hidden="true"></i>
  </button>
  <div *dropdownMenu class="dropdown-menu dropdown-menu-right-forced row-actions-menu" role="menu">
    <ng-content></ng-content>
  </div>
</div>
